import { IApiGetReportDataReq } from '../_interfaces/IApiGetReportData';
import { IApiGetAccountSymbolsReq } from '../_interfaces/IApiGetAccountSymbols';

/**
 * Converts a payload with camelCase keys into the query-shape expected by the backend,
 * where some keys use kebab-case (`account-groups`, `risk-level`).
 *
 * Used for `/data`, `/dashboard` and the per-account drilldown endpoints.
 */
export const toApiQuery = (
  payload?: IApiGetReportDataReq | IApiGetAccountSymbolsReq,
): Record<string, unknown> | undefined => {
  if (payload === undefined) {
    return undefined;
  }
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(payload)) {
    if (value === undefined) {
      continue;
    }
    if (key === 'accountGroups') {
      result['account-groups'] = value;
    } else if (key === 'riskLevel') {
      result['risk-level'] = value;
    } else {
      result[key] = value;
    }
  }
  return result;
};
